export const loading = "ports/loading";
export const err = "ports/err";
export const req = "ports/req";
export const res = "ports/res";
export const update = "ports/update";

export const deleteMaterialReq = "";
